import { Injectable } from '@angular/core';

import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';
import { Workbook,Worksheet,Alignment,Borders,Fill } from 'exceljs';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({providedIn: 'root'})
export class FvmsExcelService {
    constructor(

    ) {

    }
    excelDownload(dataList:any[], fileName:string){
      // start
      let wb = new Workbook();
      let ws:Worksheet = wb.addWorksheet("Sheet1");

      // worksheet에 header정보 작성.
      let header = Object.keys(dataList[0]);
      ws.addRow(header);

      // row data 작성
      dataList.forEach(d => {
        let tmpD = []
        header.forEach(k => tmpD.push(d[k]));
        // data.push(tmpD);
        ws.addRow(tmpD)
      });
      // data.forEach(d => ws.addRow(d));

      // file download
      wb.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], { type: 'application/octet-stream;' });
        FileSaver.saveAs(blob, fileName + EXCEL_EXTENSION);
      });

      // Old Code
      /*
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataList);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data: Blob = new Blob([excelBuffer], {type: EXCEL_TYPE});
      FileSaver.saveAs(data,  fileName + EXCEL_EXTENSION);
      */
    }
}
